import { isDefined } from '@sgme/fp';
import { useField } from 'components/common-form/hooks/useField';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { BatchQuoteRepriceLink } from 'components/shared/QuoteRepriceLink';
import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export const BatchExternalQuoteIdField: FC<ProductNodeBuilderProps> = props => {
  const {
    node: { id },
    workspaceType,
    tabIndex,
  } = props;
  const {
    data,
    metadata: { targetWorkspaceType },
  } = useField<'ExternalQuoteIdField'>(id);
  const translationKey = useFieldTranslationKey(id);

  return (
    <BlockOrientationFormGroup inputId={id} label={`form.${translationKey}` as any} workspaceType={workspaceType}>
      {isDefined(data) && (
        <BatchQuoteRepriceLink
          externalQuoteId={data}
          targetWorkspace={targetWorkspaceType ?? undefined}
          disabled={targetWorkspaceType === null}
          tabIndex={tabIndex}
        />
      )}
    </BlockOrientationFormGroup>
  );
};

BatchExternalQuoteIdField.displayName = 'BatchExternalQuoteIdField';
